export default {
    props: {
        messagesLoading: {
            type: String,
            default: undefined,
            kComposite: 'messages.loading'
        }, 
        messagesRequestFailed: {
            type: String,
            default: undefined,
            kComposite: 'messages.requestFailed'
        }, 
        messagesRetry: {
            type: String,
            default: undefined,
            kComposite: 'messages.retry'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/Messages.js